<app-alarma-datatype-tab
  *ngIf="deviceDatatype.length > 0"
  [itemCollection]="itemObservable"
  [buttonActive]="true"
  [deviceNavigate]="false"
  [parent]="parent"
  (goBackItem)="goBackNavigation($event)"
  (itemSelected)="selectedItem($event)"
  (itemUnselected)="unSelectedItem($event)"
  (itemNavigate)="navigate($event)"
  [deviceSettings]="dataTypeSettings"
  [loading]="loadingChildren"
  [dataTypeSelectedCollection]="dataTypeSelectedCollection"
></app-alarma-datatype-tab>
